enum STORAGE {
  TOKEN = 'cr_adm_tkn',
}

export default STORAGE
